var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightBulbYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.867,
    height: 80.867,
    viewBox: "0 0 80.867 80.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BULB_LIGHT",
    "data-name": "BULB LIGHT",
    transform: "translate(17.524 18.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BULB_LIGHT-2",
    "data-name": "BULB LIGHT",
    transform: "translate(-17.524 -18.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RIGHT",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M52.176,28.583a23.536,23.536,0,0,1-9,18.532,11.312,11.312,0,0,0-4.313,6.773.3.3,0,0,0-.168-.034H18.481a.573.573,0,0,0-.236.034A10.253,10.253,0,0,0,14.4,47.418,23.588,23.588,0,1,1,52.176,28.583Z",
    transform: "translate(11.844 11.851)",
    fill: "#ffd34e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M29.551,19.534a9.964,9.964,0,0,0-.168,1.752v7.48a5.925,5.925,0,0,1-5.9,5.9H15.062c-2.83,0-5.9-2.156-5.9-6.874V21.825a10.372,10.372,0,0,0-.236-2.291.573.573,0,0,1,.236-.034H29.383a.3.3,0,0,1,.168.034Z",
    transform: "translate(21.159 46.205)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M26.69,24.554H11.527a2.527,2.527,0,0,1,0-5.054H26.69a2.527,2.527,0,0,1,0,5.054Z",
    transform: "translate(21.325 46.205)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M13.777,11.648A2.528,2.528,0,0,1,11.25,9.121V2.527a2.527,2.527,0,1,1,5.054,0V9.121A2.528,2.528,0,0,1,13.777,11.648Z",
    transform: "translate(26.656)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M20.348,13.014A2.529,2.529,0,0,1,18.562,8.7l4.663-4.663A2.528,2.528,0,0,1,26.8,7.61l-4.663,4.663A2.535,2.535,0,0,1,20.348,13.014Z",
    transform: "translate(42.227 7.806)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M29.664,16.3H23.07a2.527,2.527,0,1,1,0-5.054h6.594a2.527,2.527,0,0,1,0,5.054Z",
    transform: "translate(48.676 26.656)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M25.011,27.54a2.507,2.507,0,0,1-1.786-.741l-4.663-4.663a2.528,2.528,0,0,1,3.575-3.575L26.8,23.224a2.529,2.529,0,0,1-1.789,4.316Z",
    transform: "translate(42.227 42.224)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M5.822,27.54a2.529,2.529,0,0,1-1.786-4.316L8.7,18.561a2.528,2.528,0,1,1,3.575,3.575L7.611,26.8A2.521,2.521,0,0,1,5.822,27.54Z",
    transform: "translate(7.808 42.224)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M9.121,16.3H2.527a2.527,2.527,0,1,1,0-5.054H9.121a2.527,2.527,0,1,1,0,5.054Z",
    transform: "translate(0 26.656)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M10.485,13.014A2.507,2.507,0,0,1,8.7,12.273L4.036,7.61A2.528,2.528,0,0,1,7.611,4.035L12.274,8.7a2.529,2.529,0,0,1-1.789,4.316Z",
    transform: "translate(7.808 7.806)",
    fill: "#12839a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M25.82,24.347a2.528,2.528,0,0,1-2.527-2.527,9.274,9.274,0,0,0-9.266-9.266,2.527,2.527,0,1,1,0-5.054,14.338,14.338,0,0,1,14.32,14.32A2.528,2.528,0,0,1,25.82,24.347Z",
    transform: "translate(27.249 17.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M32.795,69.018H24.371c-2.84,0-5.9-2.156-5.9-6.887V56.187A10.924,10.924,0,0,0,14.4,47.409a23.586,23.586,0,1,1,28.755-.3,10.979,10.979,0,0,0-4.465,8.521v7.49A5.9,5.9,0,0,1,32.795,69.018ZM28.536,10.059a19.573,19.573,0,0,0-3.983.414,18.521,18.521,0,0,0-7.116,32.9,16,16,0,0,1,6.089,12.817V62.13c0,.307.04,1.833.842,1.833h8.424a.843.843,0,0,0,.842-.842v-7.49a16,16,0,0,1,6.4-12.5A18.512,18.512,0,0,0,28.536,10.059Z",
    transform: "translate(11.85 11.85)",
    fill: "#0c6679"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbYellow);
export default __webpack_public_path__ + "static/media/light-bulb-yellow.e54a933b.svg";
export { ForwardRef as ReactComponent };